import { useMutation } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';

export interface ICreatePackageVariables {
  packagerId: string;
  extraction_batch_ids?: string[];
  document_ids?: string[];
}

export const useCreatePackage = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (variables: string | ICreatePackageVariables) => {
      const v: ICreatePackageVariables =
        typeof variables === 'string' ? { packagerId: variables } : variables;
      const body =
        v.extraction_batch_ids || v.document_ids
          ? {
              ...(v.extraction_batch_ids ? { extraction_batch_ids: v.extraction_batch_ids } : {}),
              ...(v.document_ids ? { document_ids: v.document_ids } : {}),
            }
          : undefined;
      return await (await glynt).packages.create(v.packagerId, body);
    },

    ...callbacks
  });
};
